module.exports = __webpack_public_path__ + "img/HOUIT-bg.9f603796.png";